import React, { PropsWithChildren } from 'react';

import { mosaiqStyled } from '../../lib';
import { mosaiqTheme } from '../../theme';
import { avatarSizeUnitMap } from '../Avatar';

import { IconAvatarProps } from './types';

import { IconAvatarContainer } from './IconAvatar.styles';

export const iconSizeUnitMap = {
  nano: 1,
  micro: 1.5,
  small: 1.75,
  regular: 2,
  large: 2,
  xlarge: 7,
  xxlarge: 7,
};

export const iconBorderRadiusSizeUnitMap = {
  nano: 0.25,
  micro: 0.5,
  small: 0.75,
  regular: 1,
  large: 1,
  xlarge: 2,
  xxlarge: 3,
};

const IconAvatar = mosaiqStyled<PropsWithChildren<IconAvatarProps>>(
  ({ size = 'regular', color, children, weight = 'regular', backgroundColor, ...props }) => {
    if (!backgroundColor)
      return React.cloneElement(children, {
        ...props,
        size: mosaiqTheme.spacing(avatarSizeUnitMap[size]),
        color: color ? mosaiqTheme.colors[color] ?? color : undefined,
        weight,
      });

    return (
      <IconAvatarContainer
        backgroundColor={mosaiqTheme.colors[backgroundColor] ?? backgroundColor}
        size={mosaiqTheme.spacing(avatarSizeUnitMap[size])}
        borderRadius={mosaiqTheme.spacing(iconBorderRadiusSizeUnitMap[size])}
      >
        {React.cloneElement(children, {
          ...props,
          size: mosaiqTheme.spacing(iconSizeUnitMap[size]),
          color: color ? mosaiqTheme.colors[color] ?? color : undefined,
          weight,
        })}
      </IconAvatarContainer>
    );
  },
);

IconAvatar.displayName = 'IconAvatar';

export default IconAvatar;
